<template>
<div id="contents">

  <div id="works" class="page_contents">

    <div id="works_contents">
      <div id="works_drawn_index">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/works/program/title.png" width="225" alt="WORKS" />
            <span>制作実績</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <worksPageNav/>

        <div id="drawn_service">
          <div class="drawn_movie_box page_main_contents">
            <h2 class="drawn_movie_box_title">ドローン撮影</h2>
            <div class="drawn_movie_box_video">
              <video src="../assets/img/works/drawn/movie.mp4" controls="controls" controlslist="nodownload"></video>
            </div>
            <p class="drawn_movie_box_read">映像制作で培ってきた経験、技術を活かし、ドローン撮影も手がけています。人気TV番組やドキュメンタリー、映画をはじめとする映像コンテンツ制作を通して磨いてきたカメラワーク、構図、演出を最大限活かしたクオリティの高い映像が特徴です。クライアントのご要望に、経験豊富なカメラマンをはじめとするスタッフの技術と工夫、熱意でお応えし、ご期待以上の映像をつくりあげます。</p>
          </div><!-- .drawn_movie_box -->
          <div class="drawn_main_contents">
            <div class="drawn_feature_box">
              <h2>テレビ朝日映像 ドローン撮影の特徴</h2>
              <div class="drawn_feature_box_inner">
                <div class="step_box">
                  <p><img src="../assets/img/works/drawn/ph01.jpg" width="305" alt=""></p>
                  <h3>①映像制作で経験を積んだプロのカメラマンによる撮影</h3>
                </div>
                <div class="step_box">
                  <p><img src="../assets/img/works/drawn/ph02.jpg" width="305" alt=""></p>
                  <h3>②4Kのカメラを使用し、<br>高画質＆迫力のある映像を実現</h3>
                </div>
                <div class="step_box">
                  <p><img src="../assets/img/works/drawn/ph03.jpg" width="305" alt=""></p>
                  <h3>③こだわりのカメラワーク、<br>構図、演出で生み出される映像美</h3>
                </div>
              </div>
            </div>
          </div><!-- .drawn_main_contents -->
          <div class="drawn_sample_box" :class="this.recruit_check() ? 'sumple_recruit_2021' : ''">
            <h2><img src="../assets/img/works/drawn/sumple_title.png" width="100" alt="SUMPLE"></h2>
            <div class="drawn_sample_box_inner">
              <div v-for="drone_item in drone_items.slice(0,3)" :key="drone_item.post_id" class="drawn_sample_list">
                <router-link v-bind:to="{name: 'drawn_show', params: {id: drone_item.post_id, link: true}}" class="hover">
                  <p><img :src="drone_item.kv_image" width="" alt="ドローンサンプル動画" /></p>
                  <h3 v-html="drone_item.title"></h3>
                </router-link>
              </div><!-- .drawn_sample_list -->
            </div>
          </div><!-- .drawn_sample_box -->
        </div><!-- #drawn_service -->
        <div id="micro_drawn_service">
          <div class="drawn_movie_box page_main_contents">
            <h2 class="drawn_movie_box_title">マイクロドローン撮影</h2>
            <div class="drawn_movie_box_video">
              <video src="//www.tv-asahipro.co.jp/wp-content/uploads/2020/12/movie02.mp4" controls="controls" controlslist="nodownload"></video>
            </div>
            <p class="drawn_movie_box_read">小型な機体を生かし、今まで入っていけなかった狭い空間でもアクロバティックに飛行、収録が可能になります。機体重量も200g未満と軽量のため事前の飛行申請等も不要となっています。</p>
          </div>
          <div class="drawn_main_contents">
            <div class="drawn_feature_box">
              <h2>テレビ朝日映像 マイクロドローン撮影の特徴</h2>
              <div class="drawn_feature_box_inner">
                <div class="step_box">
                  <p><img src="../assets/img/works/drawn/m_ph01.jpg" width="305" alt=""></p>
                  <h3>①手のひらサイズの超小型機体</h3>
                </div>
                <div class="step_box">
                  <p><img src="../assets/img/works/drawn/m_ph02.jpg" width="305" alt=""></p>
                  <h3>②HD収録に加えて４Kでの収録も可能</h3>
                </div>
                <div class="step_box">
                  <p><img src="../assets/img/works/drawn/m_ph03.jpg" width="305" alt=""></p>
                  <h3>③パイロット１名体制でのフライトが可能</h3>
                </div>
              </div>
            </div>
            <div class="micro_drawn_info page_main_contents">
              <dl class="clearfix"> <dt>機体名</dt>
                <dd>BETAFPV Beta75X</dd> <dt>重量</dt>
                <dd>105g</dd> <dt>収録フォーマット</dt>
                <dd>4K、2.7K、1440p、1080p</dd> <dt>収録メディア</dt>
                <dd>microSD</dd> <dt class="last">フライト時間</dt>
                <dd class="last">3～4分間</dd>
              </dl>
              <p class="attention">※所有数3機/業務用VTX開局済み/主に室内での使用を推奨</p>
            </div><!-- .micro_drawn_info -->
            <div class="drawn_sample_box" :class="this.recruit_check() ? 'sumple_recruit_2021' : ''">
              <h2><img src="../assets/img/works/drawn/sumple_title.png" width="100" alt="SUMPLE"></h2>
              <div class="drawn_sample_box_inner">
                <div v-for="drone_item in drone_items.slice(3,5)" :key="drone_item.post_id" class="drawn_sample_list">
                  <router-link v-bind:to="{name: 'drawn_show', params: {id: drone_item.post_id, link: true}}" class="hover">
                    <p><img :src="drone_item.kv_image" width="" alt="ドローンサンプル動画" /></p>
                    <h3 v-html="drone_item.title"></h3>
                  </router-link>
                </div><!-- .drawn_sample_list -->
              </div><!-- .drawn_sample_box_inner -->
            </div><!-- .drawn_sample_box -->
          </div>
        </div><!-- .micro_drawn_service -->
        <div class="drawn_works_list_box">
          <h2>ドローン/マイクロドローン撮影の実績</h2>
          <div class="drawn_works_list">
            <p>＜フライト実績＞テレビ朝日／Abema TV／ＮＨＫ／テレビ東京／フジテレビ／嵐 プロモーションビデオ／あしかがフラワーパークCM／茨城県 大洗町CM・PV／JTB／JAL／明治大学／小田急エージェンシー 他</p>
            <p>＜ドローン講習＞南極観測隊 隊員向けドローン講習会（安全飛行に関する座学・操縦実技） 他</p>
          </div>
        </div><!-- .drawn_works_list_box -->
        <div class="contact_btn_wrap">
          <p class="contact_btn"><router-link v-bind:to="{ name : 'contact', params : { referrer: 'ドローン事業について', link: true }}" class="c_link">ドローン撮影に関する<br />お問い合わせはこちら</router-link></p>
        </div><!-- .contact_btn_wrap -->
      </div><!-- #works_drawn_index -->
    </div><!-- #works_contents -->
  </div><!-- #works -->



</div><!-- #contents -->
</template>

<script>
import worksPageNav from './shared/worksPageNav.vue'
export default {
  name: 'drawn_index',
  data () {
    return {
      api_player_url: this.$parent.api_base_url+'/api/drone/player.php',
      api_drone_url: this.$parent.api_base_url+'/api/drone/index.php',
      loading: true,
      players: null,
      drone_items: null,
      number_image_src: [
        require("../assets/img/common/n_0.png"),
        require("../assets/img/common/n_1.png"),
        require("../assets/img/common/n_2.png"),
        require("../assets/img/common/n_3.png"),
        require("../assets/img/common/n_4.png"),
        require("../assets/img/common/n_5.png"),
        require("../assets/img/common/n_6.png"),
        require("../assets/img/common/n_7.png"),
        require("../assets/img/common/n_8.png"),
        require("../assets/img/common/n_9.png")
      ],
      error: null
    }
  },
  components: {
    worksPageNav
  },
  methods: {
    fetch_player(){
      this.$axios
        .get(this.api_player_url)
        .then(response => {
          this.players = response.data.item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally()
    },
    fetch_drone_item(){
      this.$axios
        .get(this.api_drone_url)
        .then(response => {
          this.drone_items = response.data.item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally()
    },
    recruit_check(){
      return ['recruit_2021','recruit_2022','recruit_2023','recruit_2024'].includes(this.$route.name)
    }
  },
  mounted () {
    this.fetch_player()
    this.fetch_drone_item()
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)

    $(function(){
      var video = document.getElementsByTagName('video')[0];
      video.addEventListener('ended', function() {
        video.load();
      }, false);
    });

  },
  updated (){
    var number_image_list = this.number_image_src
    $('.js-player_num').each(function(){
      replaceNumber($(this))
    });
    function replaceNumber($dom){
      $dom.html('');
      var staff_num = $dom.attr('data');
      staff_num = ('0000000000' + staff_num).slice(-3);
      $dom.append('<img src="'+number_image_list[staff_num.charAt(0)]+'">');
      $dom.append('<img src="'+number_image_list[staff_num.charAt(1)]+'">');
      $dom.append('<img src="'+number_image_list[staff_num.charAt(2)]+'">');
    }//replaceNumber
  }
}
</script>

<style scoped>



// WEBPACK FOOTER //
// src/components/drawn_index.vue